<template>
  <app-layout title="Profile">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        分析
      </h2>
    </template>
    <div class="py-12">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div>
          <ul class="flex">
            <li
              :class="showTabDisplay === 0 ? 'bg-white' : 'bg-gray-300'"
              class="cursor-pointer p-5 mx-2 rounded-t-xl"
              @click="changeTab(0)">
              プロフィール情報
            </li>
            <li
              :class="showTabDisplay === 1 ? 'bg-white' : 'bg-gray-300'"
              class="cursor-pointer p-5 mx-2 rounded-t-xl"
              @click="changeTab(1)">
              アンケート結果
            </li>
            <li
              :class="showTabDisplay === 2 ? 'bg-white' : 'bg-gray-300'"
              class="cursor-pointer p-5 mx-2 rounded-t-xl"
              @click="changeTab(2)">
              模試ごとの解答状況
            </li>
          </ul>
        </div>
        <div class="p-5 bg-white overflow-hidden shadow-xl sm:rounded-lg">
          <div>
            <ul>
              <li v-if="showTabDisplay === 0">
                <profile-summary
                  :sex-count="sexCount"
                  :job-count="jobCount"
                  :service-years-count="serviceYearsCount"
                  :area-count="areaCount"
                  :all-purchases="allPurchases"
                  :purchases-count="purchasesCount"
                  :all-examination-progress="allExaminationProgress"
                  :job-others-text="jobOthersText"
                  :service-years-others-text="serviceYearsOthersText"
                  :exam-progress-count="examProgressCount" />
              </li>
              <li v-if="showTabDisplay === 1">
                <questionnaire
                  :one-question-datas="oneQuestionDatas"
                  :one-text-datas="oneTextDatas"
                  :two-question-datas="twoQuestionDatas"
                  :three-question-datas="threeQuestionDatas"
                  :four-question-datas="fourQuestionDatas"
                  :five-question-datas="fiveQuestionDatas"
                  :six-question-datas="sixQuestionDatas"
                  :six-text-datas="sixTextDatas"
                  :seven-text-datas="sevenTextDatas" />
              </li>
              <li v-if="showTabDisplay === 2">
                <answer-status
                  :examinations="examinations"
                  :question-corrent-answer-rate="questionCorrentAnswerRate"
                  :subject-corrent-answer-rate="subjectCorrentAnswerRate"
                  :examination-score="examinationScore"
                  :user-examination-progresses="userExaminationProgresses" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import {
  defineProps,
  ref,
} from 'vue'
import ProfileSummary from './Partials/ProfileSummary'
import Questionnaire from './Partials/Questionnaire'
import AnswerStatus from './Partials/AnswerStatus'
import AppLayout from '@/Layouts/AppLayout'

const props = defineProps({
  sexCount: {
    type: Array,
    default: () => [],
  },
  jobCount: {
    type: Array,
    default: () => [],
  },
  serviceYearsCount: {
    type: Array,
    default: () => [],
  },
  areaCount: {
    type: Array,
    default: () => [],
  },
  allPurchases: {
    type: Number,
    default: 0,
  },
  purchasesCount: {
    type: Object,
    default: () => {},
  },
  allExaminationProgress: {
    type: Number,
    default: 0,
  },
  examProgressCount: {
    type: Object,
    default: () => {},
  },
  jobOthersText: {
    type: Array,
    default: () => [],
  },
  serviceYearsOthersText: {
    type: Array,
    default: () => [],
  },
  oneQuestionDatas: {
    type: Array,
    default: () => [],
  },
  oneTextDatas: {
    type: Array,
    default: () => [],
  },
  twoQuestionDatas: {
    type: Array,
    default: () => [],
  },
  threeQuestionDatas: {
    type: Array,
    default: () => [],
  },
  fourQuestionDatas: {
    type: Array,
    default: () => [],
  },
  fiveQuestionDatas: {
    type: Array,
    default: () => [],
  },
  sixQuestionDatas: {
    type: Array,
    default: () => [],
  },
  sixTextDatas: {
    type: Array,
    default: () => [],
  },
  sevenTextDatas: {
    type: Array,
    default: () => [],
  },
  examinationScore: {
    type: Array,
    default: () => [],
  },
  subjectCorrentAnswerRate: {
    type: Array,
    default: () => [],
  },
  questionCorrentAnswerRate: {
    type: Array,
    default: () => [],
  },
  examinations: {
    type: Array,
    default: () => [],
  },
  userExaminationProgresses: {
    type: Array,
    default: () => [],
  },
})

const showTabDisplay = ref(0)
const changeTab = (num) => {
  showTabDisplay.value = num
}
</script>
